// Candidate-facing copy from Rebecca's apply contract (TASK-002 brief),
// verbatim. CV_PICKER and SUBMIT_COPY match the DevGrid careers page.

export const CV_PICKER = {
  label: 'Upload your CV or resume file',
  box: 'Upload a pdf up to 2MB.',
};

export const CV_COPY = {
  required: 'Please select a CV file',
  notPdf: 'Only PDF files are accepted',
  tooLarge: 'File must be under 2 MB',
};

export const FIELD_COPY = {
  required: 'This field is required',
  email: 'Enter a valid email address',
  phone: 'Enter a valid phone number',
  salary: 'Enter a valid amount',
  phoneHint:
    'Make sure this number has WhatsApp enabled — we may reach out to you there.',
  salaryHint:
    'Enter the amount as a plain number, without a currency symbol or thousands separators.',
  salaryPlaceholder: 'e.g. 8500',
  currencyLabel: 'Currency',
};

export const SUBMIT_COPY = {
  idle: 'Submit now',
  busy: 'Submitting...',
};

export const GENERAL_ERROR = 'Something went wrong. Please try again.';

// Rebecca field errors: a message per known reason, and one for any other
// or missing reason.
export const EMAIL_UNDELIVERABLE_COPY = {
  byReason: {
    DOMAIN_NOT_FOUND:
      "That domain doesn't exist — this is very often a simple typo, like gmial.com instead of gmail.com.",
    SYNTAX_ERROR:
      "That doesn't look like a valid email address. Check for a missing @ or a stray space.",
    DISPOSABLE_DOMAIN:
      "Please use a permanent email address — temporary and disposable addresses aren't accepted.",
    NO_MX_RECORD:
      "That domain can't receive email. Please check the address or use a different one.",
  },
  fallback:
    "We couldn't verify this email address. Please check it and try again.",
};

export const ANSWER_INVALID_COPY = {
  byReason: {
    INVALID_FORMAT:
      "This answer isn't in a valid format. Please check it and try again.",
    UNKNOWN_FIELD:
      'This form changed after you opened it. Reload the page and apply again.',
  },
  fallback: 'Please check this answer and try again.',
};

export const PROCESSING_COPY = {
  title: 'Processing your application',
  body: "We're reading your CV. This usually takes a few seconds.",
};

export const TIMEOUT_COPY = {
  title: 'Still processing',
  body: "This is taking longer than usual. Your application was received — we'll email you once it's been reviewed.",
};

// Keyed by the terminal statuses in components/application-outcome.js.
export const STATUS_COPY = {
  SUCCEEDED: {
    title: 'Application submitted!',
    body: "We've received your CV and will be in touch if there's a match.",
  },
  DUPLICATE: {
    title: "You've already applied",
    body: "We already have an application from you for this role. There's no need to apply again.",
  },
  POSITION_CLOSED: {
    title: 'This role has closed',
    body: "Applications for this position closed before we could process yours. Take a look at the company's other open roles.",
  },
  UNREADABLE_CV: {
    title: "We couldn't read your CV",
    body: "Your file didn't contain any readable text — scanned or image-only PDFs often do this. Please try again with a text-based PDF.",
  },
  FAILED: {
    title: 'Something went wrong',
    body: "We couldn't process your application. Our team has been notified — please try again in a little while.",
  },
  UNDELIVERABLE_EMAIL: {
    title: "We couldn't reach that email address",
    body: "The address on your CV doesn't appear to receive email, so we'd have no way to contact you. Please apply again with a corrected address.",
  },
};

// UNDELIVERABLE_EMAIL when the position asks for an email: the candidate can
// fix it in that field instead of editing the CV.
export const undeliverableEmailWithFieldBody = (fieldName) =>
  `The address on your CV doesn't appear to receive email, so we'd have no way to contact you. Type a working one into "${fieldName}" and send the same CV again — there's no need to edit the file itself.`;

export const RETRY_COPY = {
  withEmailField: 'Enter a different email address',
  withoutEmailField: 'Upload a corrected CV',
};
